const VERSION = "7.0.0";
export {
  VERSION
};
